var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFifaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 200 70",
    width: 200,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(0.20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#093697",
    fillRule: "evenodd",
    d: "M.00012924.00029584V327.9902H103.59694V209.56308h71.9824l27.98376-71.6901h-99.96616V71.321178h121.67318L251.80777.00029584H.00012924m283.48358076 0L283.2991 327.9902h102.39685V.00029584H283.48371M787.52974 220.85504l39.44494-136.565029 40.86028 136.565029h-80.30522zM881.80376.00029745h-106.3198L657.59528 328.02097h98.96618l12.73807-44.10633h115.36568l13.33805 44.10633h101.99684L881.80376.00029745M456.40147.00029584V327.9902h103.53528V209.56308h71.90548l28.18374-71.6901H559.93675V71.321178h121.71933L708.39372.00029584H456.40147"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifaLogo);
export default __webpack_public_path__ + "static/media/fifa_logo.f84c4f0fe6c58507a93c3ba2ff780e54.svg";
export { ForwardRef as ReactComponent };